<div
  [class.pill]="pillShape"
>
  <div
    class="flex"
  >
    <div
      [innerText]="renderedTextParts.join(' ∙ ')"
    ></div>
  </div>
</div>
